// https://developer.spotify.com/documentation/web-playback-sdk/quick-start/

// // https://developer.spotify.com/documentation/general/guides/authorization-guide/
export const authEndpoint = "https://accounts.spotify.com/authorize";
//
// // established in the Spotify App -
// // https://developer.spotify.com/documentation/general/guides/app-settings/
// const redirectUri = "https://app.aspiewonder.com";
// // const redirectUri = "https://mszpila.github.io/spotify_clone/";
//
// // Spotify App ID
// // const clientId = "227bcf1c0a174f888e12f43096773e43";
// const clientId = "4d810797326f4794b2e8add211e966ea";
//
// // https://developer.spotify.com/documentation/general/guides/scopes/
// const scopes = [
// 	"user-read-playback-state",
// 	"user-read-currently-playing",
// 	"user-modify-playback-state",
// 	"user-top-read",
// 	// 'user-read-playback-position'
// 	"user-read-recently-played",
// 	"streaming",
// 	"user-read-email",
// 	"user-read-private",
// 	"user-library-read",
// 	"user-read-playback-position",
// 	"user-library-modify",
// ];
//
// // token is like a pass string that authenticate who you are
// export const loginUrl = `${authEndpoint}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scopes.join(
// 	"%20"
// )}&response_type=token&show_dialog=true"`;
//
// console.log(loginUrl);

// export const authEndpoint = "https://accounts.spotify.com/authorize";

const redirectUri = "https://app.aspiewonder.com"; // or window.location.origin

const clientId = "4d810797326f4794b2e8add211e966ea";

const scopes = [
  "user-modify-playback-state",
  "user-read-playback-position",
  "user-read-playback-state",
  "user-read-currently-playing",
  "user-read-email",
  "user-read-private",
  "playlist-modify-public",
  "user-library-modify",
  "user-library-read",
  "streaming"
];


// const scopes = [
//   "user-read-playback-state",
//   "user-read-currently-playing",
//   "user-modify-playback-state",
//   "user-top-read",
//   "user-read-recently-played",
//   "streaming",
//   "user-read-email",
//   "user-read-private",
//   "user-library-read",
//   "user-read-playback-position",
//   "user-library-modify",
// ];

const scopeParam = scopes.join(" ");

// -----------------
export const loginWithPKCE = async () => {
  const generateRandomString = (length) => {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const values = crypto.getRandomValues(new Uint8Array(length));
    return values.reduce((acc, x) => acc + possible[x % possible.length], "");
  }

  const codeVerifier  = generateRandomString(64);

  const sha256 = async (plain) => {
    const encoder = new TextEncoder()
    const data = encoder.encode(plain)
    return window.crypto.subtle.digest('SHA-256', data)
  }

  const base64encode = (input) => {
    return btoa(String.fromCharCode(...new Uint8Array(input)))
      .replace(/=/g, '')
      .replace(/\+/g, '-')
      .replace(/\//g, '_');
  }

  const hashed = await sha256(codeVerifier)
  const codeChallenge = base64encode(hashed);

  const authUrl = new URL("https://accounts.spotify.com/authorize")

  // generated in the previous step
  window.localStorage.setItem('code_verifier', codeVerifier);

  const params =  {
    response_type: 'code',
    client_id: clientId,
    scope: scopeParam,
    code_challenge_method: 'S256',
    code_challenge: codeChallenge,
    redirect_uri: redirectUri,
  }

  authUrl.search = new URLSearchParams(params).toString();
  window.location.href = authUrl.toString();
}

export const handleSpotifyRedirect = async () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  if (!code) {
    return null; // nothing to do
  }

  const codeVerifier = window.localStorage.getItem("code_verifier");
  if (!codeVerifier) {
    console.error("No code_verifier found in localStorage");
    return null;
  }

  const body = new URLSearchParams({
    client_id: clientId,
    grant_type: "authorization_code",
    code,
    redirect_uri: redirectUri,
    code_verifier: codeVerifier,
  });

  const res = await fetch("https://accounts.spotify.com/api/token", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body,
  });

  const data = await res.json();
  console.log("Spotify token response", data);

  if (data.error) {
    console.error("Error fetching token", data);
    return null;
  }

  // Save tokens (you can also store expires_in, refresh_token, etc.)
  window.localStorage.setItem("spotify_access_token", data.access_token);

  // Clean URL (remove ?code=...&state=...)
  window.history.replaceState({}, document.title, redirectUri);

  return data.access_token;
};

  // -----------------

export const loginUrl =
  `${authEndpoint}` +
  `?client_id=${encodeURIComponent(clientId)}` +
  `&redirect_uri=${encodeURIComponent(redirectUri)}` +
  `&scope=${scopeParam}` +
  `&response_type=token` +
  `&show_dialog=true`;


export const getTokenFromUrl = () => {
	// window location is just the place where is the url
	// window.location.hash =
	// #access_token=BQBkz5BZk1wpfYIGlK8lQw55_FHau-e6CgVLdB13_2jlv6WOC9iH93WLoicJIRqDmZ3u5XTI4dedfr8DBIikShE8rDNym-pUQAyvKcdEyWYr-omGoKvo5TNGRRlTmdJAcPBI_2WK0ZuSpwAnM4lvDl0czdDhPg&token_type=Bearer&expires_in=3600
	// .substring(1) removes the "#"
	// .split("&") we got 3 items:
	// 0: "access_token=BQBkz5BZk1wpfYIGlK8lQw55_FHau-e6CgVLdB13_2jlv6WOC9iH93WLoicJIRqDmZ3u5XTI4dedfr8DBIikShE8rDNym-pUQAyvKcdEyWYr-omGoKvo5TNGRRlTmdJAcPBI_2WK0ZuSpwAnM4lvDl0czdDhPg"
	// 1: "token_type=Bearer"
	// 2: "expires_in=3600"
	// reduce function returns an object
	// access_token: "BQBkz5BZk1wpfYIGlK8lQw55_FHau-e6CgVLdB13_2jlv6WOC9iH93WLoicJIRqDmZ3u5XTI4dedfr8DBIikShE8rDNym-pUQAyvKcdEyWYr-omGoKvo5TNGRRlTmdJAcPBI_2WK0ZuSpwAnM4lvDl0czdDhPg"
	// expires_in: "3600"
	// token_type: "Bearer"
	return window.location.hash
		.substring(1)
		.split("&")
		.reduce((init, item) => {
			let parts = item.split("=");
			init[parts[0]] = decodeURIComponent(parts[1]);
			return init;
		}, {});
};
